import { type PlanServicePlanComponents } from '@hungryroot/rest';
import {
  DINNER_STABLE_NAME_ID,
  LUNCH_STABLE_NAME_ID,
  findPlanComponent,
} from '../utils/utils';

export function getPricingVersionFromPlanComponents(
  planComponents: PlanServicePlanComponents
) {
  const dinnerComponent = findPlanComponent(
    planComponents.plan_components,
    DINNER_STABLE_NAME_ID
  );

  const lunchComponent = findPlanComponent(
    planComponents.plan_components,
    LUNCH_STABLE_NAME_ID
  );
  const lunchDinnerPricingVersion =
    dinnerComponent?.pricing_configurations.RECIPE_QUANTITY?.version ||
    lunchComponent?.pricing_configurations.RECIPE_QUANTITY?.version;

  return lunchDinnerPricingVersion || 0;
}
